import { Modal, ModalHeader, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { RegularScaleButton } from '../sharedStyles.styles';

export const StyledModal = styled(Modal)`
  div.modal-content {
    border-radius: 12px;
    
  }

  h5 {
    text-align: center;
  }

  @media (min-width: 992px) {
    &.modal-lg {
      max-width: 900px;
    }
  }

  ${({customstyle}) => customstyle}
`;

export const ContainerMessage = styled.div`
  text-align: center;
  color: ${props => props.theme['color_dark-gray']};
`;

export const StyledModalHeader = styled(ModalHeader)`
  border: none;
  display: flex;
  justify-content: center;
  padding-bottom: 0;
`;

export const StyledModalFooter = styled(ModalFooter)`
  border: none;

  & button,
  & input[type="button"],
  & input[type="submit"],
  & a.btn {
    border-radius: 999px !important;
  }

  ${({customstyleModalFooter}) => customstyleModalFooter}
`;

export const ModalClose = styled.div`
  font-size: .95rem;
  text-align: center;
  font-weight: 200;
  background-color: transparent;
  border: 1px solid transparent;
  color: ${props => props.theme['color_gray']};
  padding: 8px 14px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  text-decoration: none;
  position: absolute;
  top: .3rem;
  right: .8rem;
`;

export const CancelButton = styled(RegularScaleButton)`
  background: ${({$onBlue}) => ($onBlue
    ? 'linear-gradient(180deg, #ff8a2b 0%, #ff7200 55%, #e36200 100%)'
    : 'linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%')};
  color: ${props => props.theme.color_white};
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25);
`;

export const ConfirmButton = styled(RegularScaleButton)`
  background: ${props => props.disabled
    ? props.theme.color_gray
    : 'linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)'};
  margin-left: 3rem;
  color: ${props => props.theme.color_white};
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25);
`;

export const ModalTitle = styled.span`
  text-transform: uppercase;
  color: ${props => props.theme.color_purple};
`;

export const ContentContainer = styled.div`
  width: 90%;
  margin: auto;
`;

export const Title = styled.h5`
  text-transform: uppercase;
  color: ${props => props.theme.color_red};
`;

export const Container = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContainerFooter = styled.div`
  width: 40%;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Content = styled.span`
  text-align: center;
  color: ${props => props.theme.color_purple};
  font-weight: 500;
  padding: 1rem 0;
`;

export const Cancel = styled(CancelButton)`
  align-self: flex-start;
  min-width: 84px;
  height: 32px;
  padding: 0 .95rem;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%) !important;
  color: #fff !important;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
`;

export const Confirm = styled(ConfirmButton)`
  align-self: flex-end;
  min-width: 84px;
  height: 32px;
  padding: 0 .95rem;
  margin-left: 0;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%) !important;
  color: #fff !important;
  font-weight: 600;
  letter-spacing: .04em;
  text-transform: uppercase;
`;
